
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GenericUiModule } from './generic-ui-components/generic.ui.module';
import { CommonFunctioModule } from './common/commonFunction.module';
import { LoginComponent } from './pages/login/login.component';
import { LoginV2Component } from './pages/login-v2/login-v2.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { FormsModule } from '@angular/forms';
import { MatInputModule, MatSlideToggleModule, MatIconModule } from '@angular/material';
import { SharedModule } from './shared/shared.module';
import { ChartsModule } from 'ng2-charts';
import { DynamicChartComponent } from '../app/common/dynamic-chart/dynamic-chart.component';

import {
  Md2SelectModule,
  Md2DatepickerModule,
  Md2DialogModule,
  Md2DataTableModule,
  Md2TooltipModule,
  MdCommonModule
} from 'md2';

import { AuthGuardService } from './shared/services/auth-guard.service';
import { DynamicProjectChartComponent } from './common/dynamic-project-chart/dynamic-project-chart.component';
import { DynamicVendorPieChartComponent } from './common/dynamic-vendor-pie-chart/dynamic-vendor-pie-chart.component';
import { DynamicVendorInvoicePieChartComponent } from './common/dynamic-vendor-invoice-pie-chart/dynamic-vendor-invoice-pie-chart.component';
import { DynamicVendorPoBarChartComponent } from './common/dynamic-vendor-po-bar-chart/dynamic-vendor-po-bar-chart.component';
import { PoChartComponent } from './common/po-chart/po-chart.component';
import { DynamicCompanyLevelPieChartComponent } from './common/dynamic-company-level-pie-chart/dynamic-company-level-pie-chart.component';
import { AllCompanyDashboardCommonModule } from './all-company-dashboard/common.module';



const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  {
    path: 'login',
    component: LoginV2Component
  },
  {
    path: 'login-v2',
    component: LoginV2Component
  },
  // {
  //   path : 'qbsettings',
  //   loadChildren:
  //     './pages/qbsettings/qbsettings.module#QbsettingsModule'
  // },
  {
    path: 'dashboard',
    canActivate: [AuthGuardService],
    component: DashboardComponent
  },
  {
    path: 'retention-payment',
    canLoad: [AuthGuardService],
    loadChildren:
      './retention-payment/add-retention-payment/add-retention-payment.module#AddRetentionPaymentModule'

  },
  // {
  //   path:'template',
  //   canLoad: [AuthGuardService],
  //   loadChildren: './cashflow/cashflow.module#CashflowModule'
  // },
  {
    path: 'my-retention-payment',
    canLoad: [AuthGuardService],
    loadChildren:
      './retention-payment/my-retention-payment/my-retention-payment.module#MyRetentionPaymentModule'
  },
  {
    path: 'retention-payment-for-approval',
    canLoad: [AuthGuardService],
    loadChildren:
      './retention-payment/retention-payment-for-approval/retention-payment-for-approval.module#RetentionPaymentForApprovalModule'
  },
  {
    path: 'retention-payment-approval-summary',
    canLoad: [AuthGuardService],
    loadChildren:
      './retention-payment/retention-payment-approval-summary/retention-payment-approval-summary.module#RetentionPaymentApprovalSummaryModule'
  },
  {
    path: 'part-payment',
    canLoad: [AuthGuardService],
    loadChildren:
      './part-payment/add-part-payment/add-part-payment.module#AddPartPaymentModule'
  },
  {
    path: 'my-part-payment',
    canLoad: [AuthGuardService],
    loadChildren:
      './part-payment/my-part-payment/my-part-payment.module#MyPartPaymentModule'
  },
  {
    path: 'part-payment-for-approval',
    canLoad: [AuthGuardService],
    loadChildren:
      './part-payment/part-payment-for-approval/part-payment-for-approval.module#PartPaymentForApprovalModule'
  },
  {
    path: 'part-payment-approval-summary',
    canLoad: [AuthGuardService],
    loadChildren:
      './part-payment/part-payment-approval-summary/part-payment-approval-summary.module#PartPaymentApprovalSummaryModule'
  },
  {
    path: 'my-po-excess-budget',
    canLoad: [AuthGuardService],
    loadChildren:
      './podata/my-po-excess-budget/my-po-excess-budget.module#MyPoExcessBudgetModule'
  },
  {
    path: 'po-excess-budget-approvals-summary',
    canLoad: [AuthGuardService],
    loadChildren:
      './podata/po-excess-budget-approvals-summary/po-excess-budget-approvals-summary.module#PoExcessBudgetApprovalsSummaryModule'
  },
  {
    path: 'draft-po',
    canLoad: [AuthGuardService],
    loadChildren:
      './podata/draft-po/draft-po.module#DraftPoModule'
  },
  {
    path: 'po-excess-budget-for-approvals',
    canLoad: [AuthGuardService],
    loadChildren:
      './podata/po-excess-budget-for-approvals/po-excess-budget-for-approvals.module#PoExcessBudgetForApprovalsModule'
  },
  {
    path: 'allocated-grn-rack',
    canLoad: [AuthGuardService],
    loadChildren:
      './GRN/allocated-grn-rack/allocated-grn-rack.module#AllocatedGrnRackModule'
  },
  {
    path: 'allocate-grn-rack',
    canLoad: [AuthGuardService],
    loadChildren:
      './GRN/allocate-grn-rack/allocate-grn-rack.module#AllocateGrnRackModule'
  },
  {
    path: 'my-grn-excess',
    canLoad: [AuthGuardService],
    loadChildren:
      './GRN/my-grn-excess-quantity/my-grn-excess-quantity.module#MyGrnExcessQuantityModule'
  },
  {
    path: 'grn-excess-approvals-summary',
    canLoad: [AuthGuardService],
    loadChildren:
      './GRN/grn-excess-quantity-approvals-summary/grn-excess-quantity-approvals-summary.module#GrnExcessQuantityApprovalsSummaryModule'
  },
  {
    path: 'grn-excess-for-approvals',
    canLoad: [AuthGuardService],
    loadChildren:
      './GRN/grn-excess-quantity-for-approvals/grn-excess-quantity-for-approvals.module#GrnExcessQuantityForApprovalsModule'
  },
  {
    path: 'debit-credit-approvals-summary',
    canLoad: [AuthGuardService],
    loadChildren:
      './debit-credit-note/debit-credit-approvals-summary/debit-credit-approvals-summary.module#DebitCreditApprovalsSummaryModule'
  },
  {
    path: 'debit-credit-for-approvals',
    canLoad: [AuthGuardService],
    loadChildren:
      './debit-credit-note/debit-credit-for-approvals/debit-credit-for-approvals.module#DebitCreditForApprovalsModule'
  },
  {
    path: 'all-debit-credit',
    canLoad: [AuthGuardService],
    loadChildren:
      './debit-credit-note/all-debit-credit/all-debit-credit.module#AllDebitCreditModule'
  },
  {
    path: 'debit-credit-by-vendor',
    canLoad: [AuthGuardService],
    loadChildren:
      './debit-credit-note/debit-credit-by-vendor/debit-credit-by-vendor.module#DebitCreditByVendorModule'
  },
  {
    path: 'my-debit-credit',
    canLoad: [AuthGuardService],
    loadChildren:
      './debit-credit-note/my-debit-credit/my-debit-credit.module#MyDebitCreditModule'
  },
  {
    path: 'add-debit-credit-note',
    canLoad: [AuthGuardService],
    loadChildren:
      './debit-credit-note/add-debit-credit-note/add-debit-credit-note.module#AddDebitCreditNoteModule'
  },
  {
    path: 'direct-payment-approval-summary',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicePayments/direct-payment/direct-payment-approval-summary/direct-payment-approval-summary.module#DirectPaymentApprovalSummaryModule'
  },
  {
    path: 'direct-payment-for-approval',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicePayments/direct-payment/direct-payment-for-approval/direct-payment-for-approval.module#DirectPaymentForApprovalModule'
  },
  {
    path: 'all-direct-payment',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicePayments/direct-payment/all-direct-payment/all-direct-payment.module#AllDirectPaymentModule'
  },
  {
    path: 'my-direct-payment',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicePayments/direct-payment/my-direct-payment/my-direct-payment.module#MyDirectPaymentModule'
  },
  {
    path: 'add-direct-payment',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicePayments/direct-payment/add-direct-payment/add-direct-payment.module#AddDirectPaymentModule'
  },

  {
    path: 'ticket-management-system',
    canLoad: [AuthGuardService],
    loadChildren:
      './tms/ticket-management-system/ticket-management-system.module#TicketManagementSystemModule'
  },
  {
    path: 'raise-rejected-inv',
    // canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/test-direct-invoice/test-direct-invoice.module#TestDirectInvoiceModule'
  },
  {
    path: 'test-direct-invoice',
    // canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/test-direct-invoice/test-direct-invoice.module#TestDirectInvoiceModule'
  },
  {
    path: 'direct-invoice',
    // canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/test-direct-invoice/test-direct-invoice.module#TestDirectInvoiceModule'
  },
  {
    path: 'scan-invoice',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/test-direct-invoice/test-direct-invoice.module#TestDirectInvoiceModule'
  },
  {
    path: 'zero-touch-invoice',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/test-direct-invoice/test-direct-invoice.module#TestDirectInvoiceModule'
  },
  {
    path: 'mailed-invoice',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/mailed-invoice/mailed-invoice.module#MailedInvoiceModule'
  },
  {
    path: 'mailed-invoice-cc',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/mailed-invoice/mailed-invoice.module#MailedInvoiceModule'
  },
  {
    path: 'removed-mailed-invoice',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/mailed-invoice/mailed-invoice.module#MailedInvoiceModule'
  },
  {
    path: 'rejected-mailed-invoice',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/mailed-invoice/mailed-invoice.module#MailedInvoiceModule'
  },
  {
    path: 'group-mailed-invoice',
    loadChildren:
      './invoicedata/group-mailed-invoice/group-mailed-invoice.module#GroupMailedInvoiceModule'
  },
  {
    path: 'my-mailed-invoice',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/my-mailed-invoice/my-mailed-invoice.module#MyMailedInvoiceModule'
  },
  {
    path: 'removed-my-mailed-invoice',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/my-mailed-invoice/my-mailed-invoice.module#MyMailedInvoiceModule'
  },
  {
  path: 'raise-draft-direct-invoice',
  // canLoad: [AuthGuardService],
  loadChildren:
    './invoicedata/test-direct-invoice/test-direct-invoice.module#TestDirectInvoiceModule'
},
  {
    path: 'raise-direct-invoice',
    // canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/test-direct-invoice/test-direct-invoice.module#TestDirectInvoiceModule'
  },
  {
    path: 'draft-invoice',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/draft-inv/draft-inv.module#DraftInvModule'
  },
  {
    path: 'view-logistics',
    canLoad: [AuthGuardService],
    loadChildren:
      './logistics-management/view-logistic/view-logistic.module#ViewLogisticModule'
  },
  {
    path: 'add-logistics',
    canLoad: [AuthGuardService],
    loadChildren:
      './logistics-management/add-logistic/add-logistic.module#AddLogisticModule'
  },
  {
    path: 'invoice-debit-note',
    canLoad: [AuthGuardService],
    loadChildren:
      './debit-note/invoice-debit-note/invoice-debit-note.module#InvoiceDebitNoteModule'
  },
  {
    path: 'prapproval-summary',
    canLoad: [AuthGuardService],
    loadChildren:
      './prdata/prapproval-summary/prapproval-summary.module#PrapprovalSummaryModule'
  },
  {
    path: 'irapproval-summary',
    // canLoad: [AuthGuardService],
    loadChildren:
      './irdata/irapproval-summary/irapproval-summary.module#IrapprovalSummaryModule'
  },
  {
    path: 'hold-pr-for-additional-info',
    canLoad: [AuthGuardService],
    loadChildren:
      './prdata/all-hold-pr/all-hold-pr.module#AllHoldPrModule'
  },
  {
    path: 'hold-ir-for-additional-info',
    canLoad: [AuthGuardService],
    loadChildren:
      './irdata/all-hold-ir/all-hold-ir.module#AllHoldIrModule'
  },

  {
    path: 'raise-po-multi-vendor',
    loadChildren:
      './podata/raise-po-multi-vendor/raise-po-multi-vendor.module#RaisePoMultiVendorModule'
  },
  {
    path: 'raise-po-for-quotation',
    loadChildren:
      './podata/raise-po-for-quotation/raise-po-for-quotation.module#RaisePoForQuotationModule'
  },
  {
    path: 'raise-po-multi-vendor-multi-uom',
    loadChildren:
      './podata/raise-po-multi-vendor-multi-uom/raise-po-multi-vendor-multi-uom.module#RaisePoMultiVendorMultiUomModule'
  },
  {
    path: 'bulk-po-import',
    canLoad: [AuthGuardService],
    loadChildren:
      './podata/bulk-import/bulk-import.module#BulkImportModule'
  },

  {
    path: 'grn-invoice-upload-summary',
    canLoad: [AuthGuardService],
    loadChildren:
      './GRN/grn-invoice-upload-summary/grn-invoice-upload-summary.module#GrnInvoiceUploadSummaryModule'
  },
  {
    path: 'grn-invoice-file',
    canLoad: [AuthGuardService],
    loadChildren:
      './GRN/grn-invoice-upload-file/grn-invoice-upload-file.module#GrnInvoiceUploadFileModule'
  },
  {
    path: 'direct-mp',
    canLoad: [AuthGuardService],
    loadChildren: './mpdata/direct-mp/direct-mp.module#DirectMpModule'
  },
  {
    path: 'vendor-invoice-summary',
    canLoad: [AuthGuardService],
    loadChildren: './vendor/my-invoices/my-invoices.module#MyInvoicesModule'
  },
  {
    path: 'vendor-grn-summary',
    canLoad: [AuthGuardService],
    loadChildren: './vendor/my-grn/my-grn.module#MyGrnModule'
  },
  {
    path: 'vendor-irn-summary',
    canLoad: [AuthGuardService],
    loadChildren: './vendor/my-irn/my-irn.module#MyIrnModule'
  },
  {
    path: 'vendor-po-summary',
    canLoad: [AuthGuardService],
    loadChildren: './vendor/my-po/my-po.module#MyPoModule'
  },
  {
    path: 'recurring-po',
    loadChildren: './podata/recurring-po/recurring-po.module#RecurringPoModule'
  },

  {
    path: 'hold-invoice-payment',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/hold-payments/hold-payments.module#HoldPaymentsModule'
  },
  {
    path: 'my-return-goods',
    canLoad: [AuthGuardService],
    loadChildren:
      './GRN/my-return-items/my-return-items.module#MyReturnItemsModule'
  },
  {
    path: 'return-goods-approval',
    canLoad: [AuthGuardService],
    loadChildren:
      './GRN/return-items-approval/return-items-approval.module#ReturnItemsApprovalModule'
  }, {
    path: 'return-goods-approval-summary',
    canLoad: [AuthGuardService],
    loadChildren:
      './GRN/return-items-approval-summary/return-items-approval-summary.module#ReturnItemsApprovalSummaryModule'
  },
  {
    path: 'return-goods',
    canLoad: [AuthGuardService],
    loadChildren: './GRN/return-items/return-items.module#ReturnItemsModule'
  },  {
    path: 'copy-pr',
    loadChildren: './prdata/copy-pr/copy-pr.module#CopyPrModule'
  },
  {
    path: 'raise-rejected-pr',
    loadChildren: './prdata/raise-rejected-pr/raise-rejected-pr.module#RaiseRejectedPrModule'
  }, {
    path: 'rejected-pr',
    canLoad: [AuthGuardService],
    loadChildren: './prdata/rejected-pr/rejected-pr.module#RejectedPrModule'
  },
  {
    path: 'draft-pr',
    // canLoad: [AuthGuardService],
    loadChildren: './prdata/draft-pr/draft-pr.module#DraftPrModule'
  },
  {
    path: 'raise-rejected-invoice',
    loadChildren: './invoicedata/raise-rejected-invoice/raise-rejected-invoice.module#RaiseRejectedInvoiceModule'
  }, {
    path: 'rejected-invoice',
    canLoad: [AuthGuardService],
    loadChildren: './invoicedata/rejected-invoice/rejected-invoice.module#RejectedInvoiceModule'
  },
  {
    path: 'rejected-invoice-link-vendor',
    // canLoad: [AuthGuardService],
    loadChildren: './invoicedata/rejected-invoice-link-vendor/rejected-invoice-link-vendor.module#RejectedInvoiceLinkVendorModule'
  },
  {
    path: 'copy-ir',
    loadChildren: './irdata/copy-ir/copy-ir.module#CopyIrModule'
  },
  {
    path: 'add-invoice-v2',
    // canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/add-invoice-v2/add-invoice-v2.module#AddInvoiceV2Module'
  },
  {
    path: 'update-invoice',
    // canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/update-invoice/update-invoice.module#UpdateInvoiceModule'
  },
  {
    path: 'direct-invoices',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/direct-invoices/direct-invoices.module#DirectInvoicesModule'
  },
  {
    path: 'rejected-mp',
    canLoad: [AuthGuardService],
    loadChildren: './mpdata/rejected-mp/rejected-mp.module#RejectedMpModule'
  },
  {
    path: 'mp-summary',
    canLoad: [AuthGuardService],
    loadChildren:
      './mpdata/mp-approval-summary/mp-approval-summary.module#MpApprovalSummaryModule'
  },

  {
    path: 'raisepr',
    canLoad: [AuthGuardService],
    loadChildren: './prdata/raisepr/raisepr.module#RaiseprModule'
  },
  {
    path: 'raise-draft-pr',
    loadChildren: './prdata/raisepr/raisepr.module#RaiseprModule'
  },
  {
    path: 'raiseir',
    // canLoad: [AuthGuardService],
    loadChildren: './irdata/raiseir/raiseir.module#RaiseirModule'
  },
  {
    path: 'update-ir-approval',
    // canLoad: [AuthGuardService],
    loadChildren: './irdata/raiseir/raiseir.module#RaiseirModule'
  },
  {
    path: 'company',
    loadChildren: './pages/company/company.module#CompanyModule'
  },
  {
    path: 'reset-password',
    loadChildren:
      './pages/reset-password/reset-password.module#ResetPasswordModule'
  },
  {
    path: 'my-purchases-pr',
    canLoad: [AuthGuardService],
    loadChildren:
      './prdata/mypurchase-requisitions/mypurchase-requisitions.module#MypurchaseRequisitionsModule'
  },
  {
    path: 'all-pending-p2p',
    canLoad: [AuthGuardService],
    loadChildren:
      './dashboard/all-pending-p2p/all-pending-p2p.module#AllPendingP2pModule'
  },
  {
    path: 'my-ir',
    // canLoad: [AuthGuardService],
    loadChildren:
      './irdata/my-ir/my-ir.module#MyIrModule'
  },
  {
    path: 'all-ir',
    // canLoad: [AuthGuardService],
    loadChildren:
      './irdata/all-ir/all-ir.module#AllIrModule'
  },
  {
    path: 'update-pr',
    loadChildren: './prdata/update-pr/update-pr.module#UpdatePrModule'
  },
  {
    path: 'update-approval-pr',
    loadChildren: './prdata/update-approval-pr/update-approval-pr.module#UpdateApprovalPrModule'
  },
  {
    path: 'view-approval',
    loadChildren: './prdata/viewfor-approval/viewfor-approval.module#ViewforApprovalModule'
  },
  {
    path: 'allpr-approvals',
    loadChildren:
      './prdata/allpr-approval/allpr-approval.module#AllprApprovalModule'
  },
  {
    path: 'update-ir',
    loadChildren: './irdata/update-ir/update-ir.module#UpdateIrModule'
  },
  {
    path: 'view-my-ir',
    loadChildren: './irdata/update-ir/update-ir.module#UpdateIrModule'
  },
  {
    path: 'update-approval-ir',
    loadChildren: './irdata/update-approval-ir/update-approval-ir.module#UpdateApprovalIrModule'
  },
  {
    path: 'view-ir-approval',
    loadChildren: './irdata/viewfor-approval/viewfor-approval.module#ViewforApprovalModule'
  },
  {
    path: 'allir-approvals',
    loadChildren:
      './irdata/allir-approval/allir-approval.module#AllirApprovalModule'
  },
  {
    path: 'addcompany-package',
    loadChildren:
      './pages/add-company-package/add-company-package.module#AddCompanyPackageModule'
  },
  {
    path: 'my-orders',
    canLoad: [AuthGuardService],
    loadChildren:
      './podata/mypurchase-orders/mypurchase-orders.module#MypurchaseOrdersModule'
  },
  {
    path: 'po-approval',
    canLoad: [AuthGuardService],
    loadChildren:
      './podata/pofor-approval/pofor-approval.module#PoforApprovalModule'
  },
  {
    path: 'close-po',
    // canLoad: [AuthGuardService],
    loadChildren:
      './podata/close-po/close-po.module#ClosePoModule'
  },
  {
    path: 'cancel-po',
    // canLoad: [AuthGuardService],
    loadChildren:
      './podata/cancel-po/cancel-po.module#CancelPoModule'
  },
  {
    path: 'modify-po',
    // canLoad: [AuthGuardService],
    loadChildren:
      './podata/modify-po/modify-po.module#ModifyPoModule'
  },
  {
    path: 'hold-po-for-additional-info',
    canLoad: [AuthGuardService],
    loadChildren:
      './podata/all-hold-po/all-hold-po.module#AllHoldPoModule'
  },
  {
    path: 'irn-data',
    canLoad: [AuthGuardService],
    loadChildren: './IRN/irn-data/irn-data.module#IrnDataModule'
  },
  {
    path: 'new-irn',
    canLoad: [AuthGuardService],
    loadChildren: './IRN/addnew-irn/addnew-irn.module#AddnewIrnModule'
  },
  {
    path: 'new-srn',
    canLoad: [AuthGuardService],
    loadChildren: './IRN/addnew-irn/addnew-irn.module#AddnewIrnModule'
  },
  {
    path: 'myirn-summary',
    canLoad: [AuthGuardService],
    loadChildren: './IRN/myirn-summary/myirn-summary.module#MyirnSummaryModule'
  },
  {
    path: 'gate-pass',
    canLoad: [AuthGuardService],
    loadChildren: './gate-pass/gate-pass.module#GatePassModule'
  },
  {
    path: 'gate-pass-for-approval',
    canLoad: [AuthGuardService],
    loadChildren: './gate-pass-for-approval/gate-pass-for-approval.module#GatePassForApprovalModule'
  },
  {
    path: 'gate-pass-creator-summary',
    canLoad: [AuthGuardService],
    loadChildren: './gate-pass-creator-summary/gate-pass-creator-summary.module#GatePassCreatorSummaryModule'
  },
  {
    path: 'gate-pass-approval-summary',
    canLoad: [AuthGuardService],
    loadChildren: './gate-pass-approval-summary/gate-pass-approval-summary.module#GatePassApprovalSummaryModule'
  },
  {
    path: 'all-gate-pass',
    canLoad: [AuthGuardService],
    loadChildren: './all-gate-pass/all-gate-pass.module#AllGatePassModule'
  },
  {
    path: 'addinvoice',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/add-invoice/add-invoice.module#AddInvoiceModule'
  },
  {
    path: 'multi-grn-invoice',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/multi-grn-invoice/multi-grn-invoice.module#MultiGrnInvoiceModule'
  },
  {
    path: 'all-invoices',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/all-invoices/all-invoices.module#AllInvoicesModule'
  },
  {
    path: 'invoice-payments',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/invoice-payments/invoice-payments.module#InvoicePaymentsModule'
  },
  {
    path: 'hold-invoice-payment-for-additional-info',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicePayments/all-hold-payments/all-hold-payments.module#AllHoldPaymentsModule'
  },
  {
    path: 'invoice-approval',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/invoicefor-approval/invoicefor-approval.module#InvoiceforApprovalModule'
  },
  {
    path: 'pr-view-summary',
    loadChildren:
      './prdata/prview-summary/prview-summary.module#PrviewSummaryModule'
  },
  {
    path: 'ir-view-summary',
    loadChildren:
      './irdata/irview-summary/irview-summary.module#IrviewSummaryModule'
  },
  {
    path: 'poapproval-summary',
    loadChildren:
      './podata/poapproval-summary/poapproval-summary.module#PoapprovalSummaryModule'
  },
  {
    path: 'direct-irn',
    canLoad: [AuthGuardService],
    loadChildren: './IRN/direct-irn/direct-irn.module#DirectIrnModule'
  },
  {
    path: 'direct-invoice',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/direct-invoice/direct-invoice.module#DirectInvoiceModule'
  },
  {
    path: 'add-grn',
    canLoad: [AuthGuardService],
    loadChildren: './GRN/add-grn/add-grn.module#AddGrnModule'
  },
  {
    path: 'po-modification-request',
    canLoad: [AuthGuardService],
    loadChildren: './GRN/add-grn/add-grn.module#AddGrnModule'
  },
  {
    path: 'grn-summary',
    canLoad: [AuthGuardService],
    loadChildren: './GRN/grn-summary/grn-summary.module#GrnSummaryModule'
  },
  {
    path: 'material-readiness-po',
    canLoad: [AuthGuardService],
    loadChildren: './GRN/material-readiness-po/material-readiness-po.module#MaterialReadinessPoModule'
  },
  {
    path: 'hold-grn',
    // canLoad: [AuthGuardService],
    loadChildren: './GRN/hold-grn/hold-grn.module#HoldGrnModule'
  },
  {
    path: 'add-invoice-payments',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicePayments/addinvoice-payments/addinvoice-payments.module#AddinvoicePaymentsModule'
  },
  {
    path: 'add-ddc-invoice-payments',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicePayments/add-ddc-payment/add-ddc-payment.module#AddDdcPaymentModule'
  },
  {
    path: 'my-invoices',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicePayments/myinvoice-payments/myinvoice-payments.module#MyinvoicePaymentsModule'
  },
  {
    path: 'new-menu',
    loadChildren: './pages/add-menu/add-menu.module#AddMenuModule'
  },
  {
    path: 'add-payment',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicePayments/add-payment/add-payment.module#AddPaymentModule'
  },
  {
    path: 'invoice-payment-approval',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicePayments/invoice-approval/invoice-approval.module#InvoiceApprovalModule'
  },
  {
    path: 'hold-invoice-for-additional-info',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/all-hold-invoice/all-hold-invoice.module#AllHoldInvoiceModule'
  },
  {
    path: 'my-companies',
    loadChildren:
      './pages/my-company-list/my-company-list.module#MyCompanyListModule'
  },
  {
    path: 'select-user',
    loadChildren:
      './pages/select-user/select-user.module#SelectUserListModule'
  },
  {
    path: 'vendorprofile',
    canLoad: [AuthGuardService],
    loadChildren:
      './pages/vendorprofile/vendorprofile.module#VendorprofileModule'
  },
  {
    path: 'accepted-items',
    canLoad: [AuthGuardService],
    loadChildren:
      './prdata/accepted-items/accepted-items.module#AcceptedItemsModule'
  },
  {
    path: 'invoice-summary',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/invoice-summary/invoice-summary.module#InvoiceSummaryModule'
  },
  {
    path: 'ui-components',
    loadChildren:
      './common/ui-components/ui-components.module#UiComponentsModule'
  },
  {
    path: 'payment-summary',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicePayments/payment-summary/payment-summary.module#PaymentSummaryModule'
  },
  {
    path: 'vendor-orders',
    canLoad: [AuthGuardService],
    loadChildren: './podata/pofor-vendor/pofor-vendor.module#PoforVendorModule'
  },
  {
    path: 'invoice-data',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/invoicefor-vendor/invoicefor-vendor.module#InvoiceforVendorModule'
  },
  {
    path: 'invoices',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/alinvoiceforvendor/alinvoiceforvendor.module#AlinvoiceforvendorModule'
  },
  {
    path: 'all-notification',
    loadChildren:
      './pages/all-notification/all-notification.module#AllNotificationModule'
  },
  {
    path: 'po-advance-payment',
    canLoad: [AuthGuardService],
    loadChildren:
      './podata/po-advance-payment/po-advance-payment.module#PoAdvancePaymentModule'
  },
  {
    path: 'payment-approval',
    canLoad: [AuthGuardService],
    loadChildren:
      './podata/advance-payment-approval/advance-payment-approval.module#AdvancePaymentApprovalModule'
  },
  {
    path: 'advance-payments',
    canLoad: [AuthGuardService],
    loadChildren:
      './podata/myadvance-payments/myadvance-payments.module#MyadvancePaymentsModule'
  },
  {
    path: 'completed-invoice-payment',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicePayments/completed-invoice-payment/completed-invoice-payment.module#CompletedInvoicePaymentModule'
  },
  {
    path: 'raise-po',
    canLoad: [AuthGuardService],
    loadChildren: './podata/raisepo-v2/raisepo-v2.module#RaisepoV2Module'
  },
  {
    path: 'direct-po',
    canLoad: [AuthGuardService],
    loadChildren: './podata/direct-po-v2/direct-po-v2.module#DirectPoV2Module'
  },
  {
    path: 'raise-draft-po',
    loadChildren: './podata/direct-po-v2/direct-po-v2.module#DirectPoV2Module'
  },
  {
    path: 'catalogue-based-po',
    canLoad: [AuthGuardService],
    loadChildren: './podata/direct-po-v2/direct-po-v2.module#DirectPoV2Module'
  },
  {
    path: 'update-advance-payment-utr',
    canLoad: [AuthGuardService],
    loadChildren:
      './podata/add-advance-payment/add-advance-payment.module#AddAdvancePaymentModule'
  },
  {
    path: 'all-open-irn',
    canLoad: [AuthGuardService],
    loadChildren: './IRN/all-open-irn/all-open-irn.module#AllOpenIrnModule'
  },
  {
    path: 'vendor-irn-dashboard',
    canLoad: [AuthGuardService],
    loadChildren: './IRN/vendor-irn-dashboard/vendor-irn-dashboard.module#VendorIrnDashboardModule'
  },
  {
    path: 'completed-po-payment',
    canLoad: [AuthGuardService],
    loadChildren:
      './podata/completed-po-payment/completed-po-payment.module#CompletedPoPaymentModule'
  },
  {
    path: 'po-advance-payment-approval-summary',
    canLoad: [AuthGuardService],
    loadChildren:
      './podata/advance-payment-summary/advance-payment-summary.module#AdvancePaymentSummaryModule'
  },
  {
    path: 'all-approved-invoices',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/all-approved-invoices/all-approved-invoices.module#AllApprovedInvoicesModule'
  },
  {
    path: 'all-approved-payments',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicePayments/all-approved-payments/all-approved-payments.module#AllApprovedPaymentsModule'
  },
  {
    path: 'rejected-po',
    canLoad: [AuthGuardService],
    loadChildren: './podata/rejected-po/rejected-po.module#RejectedPoModule'
  },
  {
      path: 'additional-po-attachment',
      canLoad: [AuthGuardService],
      loadChildren: './podata/additional-po-attachment/additional-po-attachment.module#AdditionalPoAttachmentModule'
    },
  {
    path: 'copy-po',
    loadChildren: './podata/copy-po/copy-po.module#CopyPoModule'
  },
  {
    path: 'update-po',
    loadChildren: './podata/update-po/update-po.module#UpdatePoModule'
  },
  {
    path: 'mp-approval',
    canLoad: [AuthGuardService],
    loadChildren: './mpdata/mp-approval/mp-approval.module#MpApprovalModule'
  },
  {
    path: 'my-mp',
    canLoad: [AuthGuardService],
    loadChildren: './mpdata/my-mp/my-mp.module#MyMpModule'
  },
  {
    path: 'all-mp',
    canLoad: [AuthGuardService],
    loadChildren: './mpdata/all-mp/all-mp.module#AllMpModule'
  },
  {
    path: 'add-mp',
    canLoad: [AuthGuardService],
    loadChildren: './mpdata/raise-mp/raise-mp.module#RaiseMpModule'
  },
  {
    path: 'generate-invoice-android',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/generate-invoice-android/generate-invoice-android.module#GenerateInvoiceAndroidModule'
  },
  {
    path: 'my-generate-invoice-android',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/my-generate-invoice-android/my-generate-invoice-android.module#MyGenerateInvoiceAndroidModule'
  },
  {
    path: 'generate-invoice-android-approval',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/generatefor-invoice-android-approval/generatefor-invoice-android-approval.module#GenerateforInvoiceAndroidApprovalModule'
  },

  {
    path: 'approved-generate-invoice-android-summary',
    canLoad: [AuthGuardService],
    loadChildren:
      './invoicedata/approved-generated-invoice-android-summary/approved-generated-invoice-android-summary.module#ApprovedGeneratedInvoiceAndroidSummaryModule'
  },
  {
    path: 'add-employee-advance-payment',
   canLoad: [AuthGuardService],
    loadChildren: './employee-advance-payment/add-payment/add-payment.module#AddPaymentModule'
  },

  {
    path: 'completed-employee-advance-payment',
   canLoad: [AuthGuardService],
   loadChildren: './employee-advance-payment/completed-payment/completed-payment.module#CompletedPaymentModule'
  },

  {
    path: 'employee-advance-payment-for-approval',
   canLoad: [AuthGuardService],
   loadChildren: './employee-advance-payment/payment-for-approval/payment-for-approval.module#PaymentForApprovalModule'
  },

  {
    path: 'employee-advance-payment-approval-summary',
   canLoad: [AuthGuardService],
   loadChildren: './employee-advance-payment/payment-for-approval-summary/payment-for-approval-summary.module#PaymentForApprovalSummaryModule'
  },

  {
    path: 'update-employee-advance-payment-utr',
   canLoad: [AuthGuardService],
   loadChildren: './employee-advance-payment/update-payment-utr/update-payment-utr.module#UpdatePaymentUtrModule'
  },

  {
    path: 'my-employee-advance-payment',
   canLoad: [AuthGuardService],
   loadChildren: './employee-advance-payment/my-advance-payment/my-advance-payment.module#MyAdvancePaymentModule'
  },

  {
    path: 'my-pending-p2p',
    canLoad: [AuthGuardService],
    loadChildren:
      './dashboard/my-pending-p2p/my-pending-p2p.module#MyPendingP2pModule'
  },
{
    path: 'my-requested-pending',
    canLoad: [AuthGuardService],
    loadChildren:
      './dashboard/my-requested-pending-p2p-item/my-requested-pending-p2p-item.module#MyRequestedPendingP2pItemModule'
  },

{
  path: 'pending-p2p-approval-Wise',
  canLoad: [AuthGuardService],
  loadChildren:
    './dashboard/pending-p2p-approval-wise/pending-p2p-approval-wise.module#PendingP2pApprovalWiseModule'
},
{
  path: 'vendor-pending-po',
  canLoad: [AuthGuardService],
  loadChildren:
    './vendor/po/pending-po/pending-po.module#PendingPoModule'
},
{
  path: 'vendor-fulfilled-po',
  // canLoad: [AuthGuardService],
  loadChildren:
    './vendor/po/fulfilled-po/fulfilled-po.module#FulfilledPoModule'
},
{
  path: 'vendor-add-invoice',
  canLoad: [AuthGuardService],
  loadChildren:
    './vendor/invoice/add-invoice/add-invoice.module#AddInvoiceModule'
},
{
  path: 'vendor-my-invoice',
  canLoad: [AuthGuardService],
  loadChildren:
    './vendor/invoice/my-invoices/my-invoices.module#MyInvoicesModule'
},
{
  path: 'vendor-direct-invoice',
  // canLoad: [AuthGuardService],
  loadChildren:
    './vendor/invoice/vendor-direct-invoice/vendor-direct-invoice.module#VendorDirectInvoiceModule'
},
{
  path: 'rejected-vendor-invoice',
  // canLoad: [AuthGuardService],
  loadChildren:
    './vendor/invoice/rejected-vendor-invoice/rejected-vendor-invoice.module#RejectedVendorInvoiceModule' 
},
{
  path: 'invoice-dashboard',
  canLoad: [AuthGuardService],
  loadChildren:
    './vendor/invoice-dashboard/invoice-dashboard.module#InvoiceDashboardModule'
},
{
  path: 'rejected-vendor-invoice-dashboard',
  // canLoad: [AuthGuardService],
  loadChildren:
    './vendor/rejected-vendor-invoice-dashboard/rejected-vendor-invoice-dashboard.module#RejectedVendorInvoiceDashboardModule'
},
{
  path: 'vendor-payments',
  // canLoad: [AuthGuardService],
  loadChildren:
    './vendor/vendor-payment-summary/vendor-payment-summary.module#PaymentSummaryModule'
},
{
  path: 'hold-vendor-invoices',
  // canLoad: [AuthGuardService],
  loadChildren:
    './vendor/holdinvoice-dashboard/holdinvoice-dashboard.module#HoldInvoiceDashboardModule'
},
{
  path: 'return-to-store-acceptance',
  // canLoad: [AuthGuardService],
  loadChildren:
    './prdata/return-to-store-acceptance/return-to-store-acceptance.module#ReturnToStoreAcceptanceModule'
},
{
  path: 'close-pr',
  canLoad: [AuthGuardService],
  loadChildren:
    './prdata/close-pr/close-pr.module#ClosePrModule'
},
{
  path: 'direct-po-import',
  canLoad: [AuthGuardService],
  loadChildren: './podata/direct-po-import/direct-po-import.module#DirectPoImportModule'
},
{
  path: 'adhoc-advance-payment',
  canLoad: [AuthGuardService],
  loadChildren:
    './adhoc-advance-payment/adhoc-advance-payment/adhoc-advance-payment.module#AdhocAdvancePaymentModule'
},
{
  path: 'adhoc-advance-payment-approval',
  canLoad: [AuthGuardService],
  loadChildren:
    './adhoc-advance-payment/adhoc-advance-payment-approval/adhoc-advance-payment-approval.module#AdhocAdvancePaymentApprovalModule'
},
{
  path: 'adhoc-advance-payment-summary',
  canLoad: [AuthGuardService],
  loadChildren:
    './adhoc-advance-payment/adhoc-advance-payment-summary/adhoc-advance-payment-summary.module#AdhocAdvancePaymentSummaryModule'
},
{
  path: 'my-adhoc-advance-payment',
  canLoad: [AuthGuardService],
  loadChildren:
    './adhoc-advance-payment/my-adhoc-advance-payment/my-adhoc-advance-payment.module#MyAdhocAdvancePaymentModule'
},
{
  path: 'qb-error-log',
  canLoad: [AuthGuardService],
  loadChildren:
    './pages/qb-error-log/qb-error-log.module#QbErrorLogModule'
},
{
  path: 'pending-pr-for-rfq-no',
  loadChildren:
    './dashboard/pending-pr-for-rfq-no/pending-pr-for-rfq-no.module#PendingPrForRfqNoModule'
},
{
  path: 'escalation-matrix',
  canLoad: [AuthGuardService],
  loadChildren:
    './escalation-matrix/add-record/add-record.module#AddRecordModule'
},
{
  path: 'view-matrix',
  // canLoad: [AuthGuardService],
  loadChildren:
    './escalation-matrix/my-record/my-record.module#MyRecordModule'
},
{
  path: 'auto-generated-inv',
  // canLoad: [AuthGuardService],
  loadChildren:
    './recurring-invoicedata/auto-generated-inv/auto-generated-inv.module#AutoGeneratedInvModule'
},
{
  path: 'raise-recurring-direct-invoice',
  // canLoad: [AuthGuardService],
  loadChildren:
    './invoicedata/test-direct-invoice/test-direct-invoice.module#TestDirectInvoiceModule'
},
{
  path: 'all-recurring-inv',
  // canLoad: [AuthGuardService],
  loadChildren:
    './recurring-invoicedata/all-invoices/all-invoices.module#AllInvoicesModule'
},
{
  path: 'create-recurring-inv',
  // canLoad: [AuthGuardService],
  loadChildren:
    './recurring-invoicedata/test-direct-invoice/test-direct-invoice.module#TestDirectInvoiceModule'
},
{
  path: 'draft-recurring-inv',
  // canLoad: [AuthGuardService],
  loadChildren:
    './recurring-invoicedata/draft-inv/draft-inv.module#DraftInvModule'
},
{
  path: 'recurring-inv-for-approval',
  // canLoad: [AuthGuardService],
  loadChildren:
    './recurring-invoicedata/invoicefor-approval/invoicefor-approval.module#InvoiceforApprovalModule'
},
{
  path: 'approved-summary-recurring-inv',
  // canLoad: [AuthGuardService],
  loadChildren:
    './recurring-invoicedata/invoice-summary/invoice-summary.module#InvoiceSummaryModule'
},
{
  path: 'update-recurring-inv',
  loadChildren:
    './recurring-invoicedata/update-invoice/update-invoice.module#UpdateInvoiceModule'
},
{
  path: 'add-direct-advance-payment',
  loadChildren:'./adhoc-advance-payment/add-direct-advance-payment/add-direct-advance-payment.module#AddDirectAdvancePaymentModule'
},{
  path: 'update-add-direct-advance-payment',
  loadChildren:'./adhoc-advance-payment/update-add-direct-advance-payment/update-add-direct-advance-payment.module#UpdateAddDirectAdvancePaymentModule'
},
{
  path: 'draft-e-mail',
  canLoad: [AuthGuardService],
  loadChildren:
    './communication/draft-e-mail/draft-e-mail.module#DraftEMailModule'
},
{
  path: 'my-e-mail',
  canLoad: [AuthGuardService],
  loadChildren:
    './communication/my-e-mail/my-e-mail.module#MyEMailModule'
},
{
  path: 'all-e-mail',
  canLoad: [AuthGuardService],
  loadChildren:
    './communication/all-e-mail/all-e-mail.module#AllEMailModule'
},
{
  path: 'copy-new-direct-invoice',
  loadChildren:'./invoicedata/test-direct-invoice/test-direct-invoice.module#TestDirectInvoiceModule'
},
{
  path: 'card-menu',
  // canLoad: [AuthGuardService],
  component: DashboardComponent
},
{
  path: 'self-reminder',
  canLoad: [AuthGuardService],
  loadChildren:
    './escalation-matrix/self-reminder/self-reminder.module#SelfReminderModule'
},
{
  path: 'vendor-payments',
  // canLoad: [AuthGuardService],
  loadChildren:
    './vendor/vendor-payment-summary/vendor-payment-summary.module#PaymentSummaryModule'
},
{
  path: 'update-debit-credit-note',
  // canLoad: [AuthGuardService],
  loadChildren: './debit-credit-note/update-debit-credit-note/update-debit-credit-note.module#UpdateDebitCreditNoteModule'
},
{
  path: 'vendor-add-credit-note',
  canLoad: [AuthGuardService],
  loadChildren:'./vendor/vendor-add-credit-note/vendor-add-credit-note.module#VendorAddCreditNoteModule'
},
{
  path: 'vendor-my-credit-notes',
  canLoad: [AuthGuardService],
  loadChildren:'./vendor/vendor-my-credit-notes/vendor-my-credit-note.module#VendorMyCreditNoteModule'
},
{
  path: 'vendor-rejected-credit-notes',
  canLoad: [AuthGuardService],
  loadChildren:'./vendor/vendor-rejected-credit-notes/vendor-rejected-credit-note.module#VendorRejectedCreditNoteModule'
},
{
  path: 'vendor-rejected-po',
  canLoad: [AuthGuardService],
  loadChildren: './vendor/po/pending-po/pending-po.module#PendingPoModule',
},
{
  path: 'vendor-mdcc-po',
  canLoad: [AuthGuardService],
  loadChildren: './vendor/po/pending-po/pending-po.module#PendingPoModule',
},
{
  path: 'company-license',
  loadChildren: './pages/company-license/company-license.module#CompanyLicenseModule'
},
{
  path: 'replication-grouping',
  // canLoad: [AuthGuardService],
  loadChildren: './replication-grouping/replication-grouping/replication-grouping.module#ReplicationGroupingModule'
},


  {
    path: '**',
    redirectTo: 'login'
  }
];

const legacyRoutes = routes.filter((r) => r.path !== '**').map((r) => ({ ...r }));
routes.splice(routes.length - 1, 0, {
  path: 'ops-core',
  children: legacyRoutes
});

@NgModule({
  imports: [
    CommonModule,
    CommonFunctioModule,
    SharedModule,
    Md2DataTableModule,
    FormsModule,
    MatInputModule,
    Md2TooltipModule,
    MdCommonModule,
    Md2SelectModule,
    Md2DatepickerModule,
    Md2DialogModule,
    MatSlideToggleModule,
    MatIconModule,
    GenericUiModule,
    ChartsModule,
    AllCompanyDashboardCommonModule,
    RouterModule.forRoot(routes, {
      useHash: true
    })
  ],
  exports: [RouterModule],
  declarations: [
    LoginComponent,
    LoginV2Component,
    DashboardComponent,
    DynamicChartComponent,
    DynamicProjectChartComponent,
    DynamicVendorPieChartComponent,
    DynamicVendorInvoicePieChartComponent,
    DynamicVendorPoBarChartComponent,
    PoChartComponent,
    DynamicCompanyLevelPieChartComponent
  ]
})

export class AppRoutingModule { }



// WEBPACK FOOTER //
// /codebuild/output/src3329053404/src/src/app/app-routing.module.ts